/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { VegaButtonLink, VegaFlex, VegaAppHeaderButton, VegaPopover, VegaButton, VegaBox, VegaTooltip, VegaIcon, VegaFont, VegaCounterBadge } from '@heartlandone/vega-react';
import { useKeycloak } from '@react-keycloak/web';
import { REDIRECT_URI_ROOT } from 'Chores/Api';
import { firstUpperCase, breadcrumbHandle, emailConvertLabel, getDefaultUserAvatar, dateTimeFormat, getFromlocalStorage, copyToClipboard, objectToQueryParams, setFromlocalStorage, checkPermissionForUserProject } from 'Chores/utils';
import './header.scss';
import UserEditProfileModal from '../../Containers/UserManagement/UserProfile/UserEditProfileModal';
import { getUserInfoAvatar, updateUserLogout, getUnreadMessageCount } from 'Chores/request';
import { setShowActionModal } from 'Slices/Retro/retroSlice';
import { RETRO_STATUS, PROJECT_PERMISSIONS } from 'Chores/Constants';
import { downloadRetroPdf } from 'Containers/Retro/export';
import store from 'store';
import { FE_ROUTES } from 'Chores/Api';

const Header = () => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const userId = keycloak?.idTokenParsed?.sub;
  const [breadcrumb, setBreadcrumb] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const menus = useSelector((state) => state.common.menus);
  const title = location.pathname.split('/').filter((item) => item);
  const [isUserEditProfileModalOpened, setIsUserEditProfileModalOpened] = useState(false);
  const [userAvatar, setUserAvatar] = useState('');
  const [userInfoAvatar, setUserInfoAvatar] = useState({
    id: '',
    userId: '',
    name: '',
    phone: '',
    email: '',
    avatar: '',
    nativeName: ''
  });
  const [unreadCount, setUnreadCount] = useState(0);
  const currentPage = useSelector((state) => state.common.currentPage);
  const currentRetro = useSelector((state) => state.retro.currentRetro);
  const dateFilter = useSelector((state) => state.retro.dateFilter);
  const pagination = useSelector((state) => state.retro.pagination);
  const headerTitle = useSelector((state) => state.header.headerTitle);
  const headerSubTitle = useSelector((state) => state.header.headerSubTitle);
  const isBreadcrumbShow = useSelector((state) => state.header.isBreadcrumbShow);
  const [allUserAvatar, setAllUserAvatar] = useState({});

  useEffect(() => {
    if (['retroDetail', 'retroHome'].includes(currentPage)) {
      const avatarData = getFromlocalStorage('allUserAvatar');
      setAllUserAvatar(avatarData);
    }
  }, [currentPage]);

  useEffect(() => {
    setBreadcrumb(breadcrumbHandle(location.pathname, menus));
  }, [location, menus]);

  useEffect(() => {
    if (keycloak?.idTokenParsed?.sub !== undefined) {
      loadUserInfoAvatar();
    }
  }, [keycloak?.idTokenParsed]);

  useEffect(() => {
    let isMounted = true;

    const fetchUnreadCount = async () => {
      if (!userId) {
        if (isMounted) {
          setUnreadCount(0);
        }
        return;
      }

      try {
        const result = await getUnreadMessageCount(userId);
        let nextCount = 0;

        if (typeof result === 'number') {
          nextCount = result;
        } else if (result && typeof result === 'object') {
          if (typeof result.count === 'number') {
            nextCount = result.count;
          } else if (typeof result.unreadCount === 'number') {
            nextCount = result.unreadCount;
          }
        }

        if (!Number.isFinite(nextCount)) {
          nextCount = 0;
        }

        if (isMounted) {
          setUnreadCount(nextCount);
        }
      } catch (error) {
        if (isMounted) {
          setUnreadCount(0);
        }
      }
    };

    fetchUnreadCount();

    return () => {
      isMounted = false;
    };
  }, [userId]);

  const isEnableAssessment = () => {
    if (store.getState().retro.projectId) {
      return checkPermissionForUserProject(store.getState().retro.projectId, PROJECT_PERMISSIONS.RETROBOARD);
    }
  };

  const loadUserInfoAvatar = () => {
    getUserInfoAvatar(keycloak.idTokenParsed.sub).then((res) => {
      if (!res.name || res.name.trim() === '') {
        res.name = emailConvertLabel(keycloak?.idTokenParsed?.email);
      }

      if (res.avatar === null || res.avatar === '') {
        setUserAvatar(getDefaultUserAvatar());
      } else {
        setUserAvatar(res.avatar);
      }
      setUserInfoAvatar(res);
    });
  };

  const onLoginOut = () => {
  setFromlocalStorage('loginRedirect', '');
  updateUserLogout();
  // Clear Keycloak tokens from localStorage before logout
  localStorage.removeItem('kc_token');
  localStorage.removeItem('kc_refreshToken');
  localStorage.removeItem('kc_idToken');
  keycloak.logout({ redirectUri: REDIRECT_URI_ROOT });
  };

  const toggleRetroActionModal = (open) => {
    dispatch(setShowActionModal(open));
  };

  const enterRetroAssement = () => {
    const currentPath = window.location.pathname;
    const newPath = currentPath.endsWith('/') ?
    currentPath + 'retro-assessment' :
    currentPath + '/retro-assessment';
    navigate(newPath);
  };

  const isAnalysisPage = () => {
    return window.location.pathname.includes('sprint-assessment-analysis');
  };

  const onCopyRetroDetailLink = () => {
    const params = {
      redirect: 'retro-detail',
      projectId: currentRetro.projectId,
      retroId: currentRetro.id,
      dateFilterType: dateFilter.type,
      startTime: dateFilter.value[0],
      endTime: dateFilter.value[1],
      page: pagination.page
    };
    const url = process.env.REACT_APP_HOST + location.pathname.split('/retro-detail')[0] + objectToQueryParams(params);
    copyToClipboard(url, 'The link has been copied to clipboard.');
  };

  const onDownloadRetro = () => {
    downloadRetroPdf(currentRetro);
  };

  const retroDetailLeftHtml = () => {
    return (
      <>
        <div className={currentPage === 'retroDetail' ? 'v-ml-size-12' : 'v-hidden'}>
          <div className='v-font-h5'>{currentRetro.name}</div>
          <div className='v-font-field-label-sm v-text-secondary'>Created by {allUserAvatar[currentRetro.userId]?.name} | {currentRetro.status == RETRO_STATUS.CLOSED ? 'Closed' : 'Created'}: {dateTimeFormat(currentRetro.status == RETRO_STATUS.CLOSED ? currentRetro.endTime : currentRetro.startTime, 'DD MMM YYYY')}</div>
        </div>
        <div className={currentPage === 'retroAssessmentScore' ? 'v-ml-size-12' : 'v-hidden'}>
          <div className='v-font-h5'>{currentRetro.name}</div>
          <div className='v-font-field-label-sm v-text-secondary'>Created by {allUserAvatar[currentRetro.userId]?.name} | {currentRetro.status == RETRO_STATUS.CLOSED ? 'Closed' : 'Created'}: {dateTimeFormat(currentRetro.status == RETRO_STATUS.CLOSED ? currentRetro.endTime : currentRetro.startTime, 'DD MMM YYYY')}</div>
        </div>
      </>
    );
  };

  const retroDetailRightHtml = () => {
    return (
      <VegaFlex alignItems='center' gap={'size-12'}>
        {isEnableAssessment() && <VegaTooltip text="Assessment Settings"><VegaAppHeaderButton avatar={{ icon: 'fa-regular fa-folder-gear' }} size='small' onVegaClick={() => enterRetroAssement()} className={['retroHome'].includes(currentPage) ? '' : 'v-hidden'}></VegaAppHeaderButton></VegaTooltip>}
        <VegaAppHeaderButton avatar={{ icon: 'fas fa-tasks' }} size='small' onVegaClick={() => toggleRetroActionModal(true)} className={['retroDetail', 'retroHome', 'retroAssessmentScore'].includes(currentPage) ? '' : 'v-hidden'}></VegaAppHeaderButton>
        <VegaAppHeaderButton avatar={{ icon: 'fas fa-download' }} size='small' className={['retroDetail', 'retroAssessmentScore'].includes(currentPage) ? '' : 'v-hidden'} onVegaClick={() => onDownloadRetro()}></VegaAppHeaderButton>
        <VegaAppHeaderButton avatar={{ icon: 'fas fa-external-link' }} size='small' className={['retroDetail', 'retroAssessmentScore'].includes(currentPage) ? '' : 'v-hidden'} onVegaClick={() => onCopyRetroDetailLink()}></VegaAppHeaderButton>
      </VegaFlex>
    );
  };

  const toggle = () => {
    const leftNav = document.querySelector('vega-left-nav');
    leftNav.toggle();
  };

  const openMessageBox = () => {
    const pop = document.querySelector('vega-popover');
    if (pop && typeof pop.hide === 'function') pop.hide();

    const leftNav = document.querySelector('vega-left-nav');
    const leftNavIsOpen = leftNav && leftNav.classList && leftNav.classList.contains('open');

    navigate(FE_ROUTES.HOME + '/message', { state: { userInfo: userInfoAvatar, isRedirect: true } });
    if (leftNavIsOpen) toggle();
  };

  const openUserProfile = () => {
    const pop = document.querySelector('vega-popover');
    if (pop && typeof pop.hide === 'function') pop.hide();

    const leftNav = document.querySelector('vega-left-nav');
    const leftNavIsOpen = leftNav && leftNav.classList && leftNav.classList.contains('open');

    navigate(FE_ROUTES.HOME + `/profile?id=${userInfoAvatar.userId}&isEdit=false`);
    if (leftNavIsOpen) toggle();
  };

  return (
    <VegaFlex gap="size-16" direction="row" alignItems="center" justifyContent="space-between">
      <VegaFlex justifyContent="start" alignItems="center">
        <VegaAppHeaderButton
          avatar={{
            icon: 'hb-menu'
          }}
          onVegaClick={toggle}
        ></VegaAppHeaderButton>
        <VegaBox className={currentPage == 'retroDetail' || currentPage == 'retroAssessmentScore' ? 'v-hidden' : ''} padding={{ 'y': 'size-8', 'x': 'size-8', 'left': 'size-12' }}>
          <h1 className="v-font-h4 vega-flex-shrink-0">
            {headerTitle || breadcrumb[breadcrumb.length - 1]?.name || firstUpperCase(title[title.length - 1].replace(/[-/_]/g, ' '))}
          </h1>
          {isBreadcrumbShow && (
            <ul className={`vega-flex-shrink-0 ${breadcrumb.length > 0 ? 'v-mt-size-8' : ''} ${isAnalysisPage() ? 'v-hidden' : ''}`}>
              {breadcrumb.map(({ title, link }, index) => (
                <React.Fragment key={index}>
                  <li
                    className={`${(index === breadcrumb.length - 1 || title === 'Retro Board') ? 'v-text-black' : 'v-text-link'
                      } v-font-p2-short v-float-left`}
                  >
                    {index !== breadcrumb.length - 1 ? (
                      (title !== 'Retro Board' ? <VegaButtonLink onVegaClick={() => navigate(`${link}`)} label={title}></VegaButtonLink> : title)
                    ) : (
                      title !== 'Retro Assessment' ? title : null
                    )}
                  </li>
                  {index !== breadcrumb.length - 1 ? (
                    <li className="v-px-size-8 v-text-black v-font-p2-short v-float-left">{title === 'Retro Board' ? null : '|'}</li>
                  ) : null}
                </React.Fragment>
              ))}
            </ul>
          )}
          {headerSubTitle && (
            <VegaFont variant='font-h6' color='text-secondary'>{headerSubTitle}</VegaFont>
          )}
        </VegaBox>
        {retroDetailLeftHtml()}
      </VegaFlex>
      <VegaFlex alignItems='center' gap={'size-12'}>
        <VegaCounterBadge count={unreadCount} dot={Number(unreadCount) > 0 ? true : false} offset={['-10', 9]}>
          <VegaAppHeaderButton
            avatar={{
              icon: 'fas fa-bell'
            }}
            onVegaClick={openMessageBox}
            id='messageboxHeaderButton'
          ></VegaAppHeaderButton>
        </VegaCounterBadge>
        {retroDetailRightHtml()}
        <div className="vega-flex-shrink-0 capitalize">
          <VegaPopover
            id="user-profile-popover"
            class='user-profile-popover'
            size="380"
            placement="bottom"
            alignment="end"
          >
            <VegaAppHeaderButton
              slot='popover-content'
              id="VegaAppHeaderButton"
              avatar={{ src: userAvatar }}
              label={userInfoAvatar.name}
              dropdown={{
                'source': [{}],
                'positionRelativeTo': '.user-profile-popover'
              }}
            />
            <div slot='popover' className="user-popover">
              <img className="user-image" src={userAvatar}></img>
              <p className="user-name">{userInfoAvatar.name} {userInfoAvatar.nativeName ? <span className="user-info-native-name">({userInfoAvatar.nativeName})</span> : null}</p>
              <VegaFlex direction="col" justifyContent="start" gap={'size-8'} margin={{ default: { top: 'size-24', left: 'size-16' } }} className="user-info">
                <p className="v-text-secondary"><VegaIcon icon="fa-light fa-envelope" className='user-info-icon'></VegaIcon>{userInfoAvatar.email}</p>
                <p className="v-text-secondary"><VegaIcon icon="fa-light fa-phone" className='user-info-icon'></VegaIcon>{userInfoAvatar.phone}</p>
              </VegaFlex>
              <div className="v-w-full v-border-0 v-border-b v-border-solid v-border-color-divider v-mb-size-16 v-mt-size-32"></div>
              <VegaButtonLink
                size="small"
                icon="settings"
                icon-type="icon"
                icon-align="left"
                label="Edit Profile"
                onVegaClick={(e) => openUserProfile()}
              ></VegaButtonLink>
              <div className="v-w-full v-border-0 v-border-b v-border-solid v-border-color-divider v-mb-size-24 v-mt-size-16"></div>
              <div className="user-signout">
                <VegaButton
                  variant="secondary"
                  size="small"
                  onVegaClick={(e) => onLoginOut()}
                >
                  Sign Out
                </VegaButton>
              </div>
            </div>
          </VegaPopover>
        </div>
      </VegaFlex>
      <UserEditProfileModal
        userInfoAvatar={userInfoAvatar}
        isOpened={isUserEditProfileModalOpened}
        onClose={setIsUserEditProfileModalOpened}
        loadUserInfoAvatar={loadUserInfoAvatar}
      />
    </VegaFlex>
  );
};

export default Header;
